export const pusherConfig = {
    app_key: "2778cd946a7e0a4d498d",
    app_cluster: "mt1",
  };
  